'use client';

import { Component } from '@/shared';
import { Session } from "next-auth";
import { signOut } from "next-auth/react";
import { getClasses } from "@/classes";
import { useNavigation } from '@/app/navigation-context';

export interface LogoutComponent extends Component {
  label: string,
}

function checkLogoutComponent(component: Component): LogoutComponent {
  const { label, ...props } = component as LogoutComponent;

  if (!label) {
    throw new Error(`no label in logout component`);
  }

  return {
    ...props,
    label,
  };
}

export default function Logout({ component, session, }: { component: Component, session: Session | null }) {
  const { label, classes, } = checkLogoutComponent(component);

  const { startLoading, } = useNavigation();

  return session && (
    <a
      className={getClasses([`logout-component cursor-pointer`, classes,])}
      onClick={() => { startLoading(`/api/auth/signout`); setTimeout(() => signOut(), 0); }}
    >
      <p>{label}</p>
    </a>
  );
}
